// PDFTable.js
import React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Chip,
  Checkbox,
} from "@mui/material";

const styles = {
  "Payment done,Awaiting for Bills": { bg: "#FFBF00", text: "#000000" },
  "Bills Quality Hold": { bg: "#FFA500", text: "#000000" },
  "Bills Accepted": { bg: "#008100", text: "#FFFFFF" },
};

const PDFTable = ({
  tableData,
  selectedTransactions,
  setSelectedTransactions,
  currentPage,
}) => {
  const handleCheckboxChange = (event, trans_id) => {
    if (event.target.checked) {
      setSelectedTransactions((prev) => [...prev, trans_id]);
    } else {
      setSelectedTransactions((prev) => prev.filter((id) => id !== trans_id));
    }
  };
  // console.log(currentPage)
  return (
    <TableContainer sx={{ maxHeight: 400, mt: 4 }}>
      <Table aria-label="Payment Voucher Table">
        <TableHead>
          <TableRow>
            <TableCell> Select </TableCell> {/* Checkbox Column Header */}
            <TableCell> S.NO </TableCell>
            <TableCell> Project ID </TableCell>
            <TableCell> Payment Type </TableCell>
            <TableCell> Sender Name </TableCell>
            <TableCell> Vendor Name </TableCell>
            <TableCell> PO Number </TableCell>
            <TableCell> Amount </TableCell>
            <TableCell> Status </TableCell>
            <TableCell> Date </TableCell>
            <TableCell> Remarks </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((transaction, index) => (
            <TableRow key={transaction.id}>
              <TableCell>
                <Checkbox
                  checked={selectedTransactions.includes(transaction.trans_id)}
                  onChange={(e) =>
                    handleCheckboxChange(e, transaction.trans_id)
                  }
                />
              </TableCell>
              <TableCell>{(currentPage - 1) * 10 + index + 1}</TableCell>
              <TableCell>{transaction.project_id}</TableCell>
              <TableCell>{transaction.payment_type}</TableCell>
              <TableCell>{transaction.sender_name}</TableCell>
              <TableCell>{transaction.vendorname}</TableCell>
              <TableCell>{transaction.ponumber}</TableCell>
              <TableCell>{transaction.amount}</TableCell>
              <TableCell>
                <Chip
                  label={transaction.status}
                  color={
                    styles[transaction.status]
                      ? styles[transaction.status].bg
                      : "default"
                  }
                />
              </TableCell>
              <TableCell>{transaction.createdAt}</TableCell>
              <TableCell>{transaction.pr_remarks}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PDFTable;
